export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[620px] md:min-h-[760px] flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20cover%20for%20a%20materials%20archive%20landing%20page%2C%20layered%20translucent%20document%20sheets%20and%20stacked%20video%20frame%20panels%20floating%20over%20a%20warm%20cream%20textured%20background%20with%20soft%20amber%20and%20burnt%20orange%20gradient%20light%2C%20minimal%20geometric%20composition%2C%20cinematic%20vignette%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=nh-hero-2026a&orientation=landscape"
          alt="网红黑料素材归档入口封面，网红黑料实锤与原始素材视觉"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-8 py-28">
        <div className="max-w-3xl mx-auto text-center nh-fade-up">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 text-xs md:text-sm font-label tracking-wide">
            <i className="ri-verified-badge-line text-accent-300"></i>
            有图有真相 · 素材归档入口
          </span>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl font-black text-background-50 leading-tight">
            网红黑料
            <span className="block mt-3 text-xl md:text-3xl font-semibold text-accent-300">素材归档 · 核验入口</span>
          </h1>

          <p className="mt-6 text-sm md:text-base leading-relaxed text-background-100">
            吃瓜最怕没实锤。这里集中整理<strong className="font-semibold text-accent-200">网红黑料实锤</strong>、<strong className="font-semibold text-accent-200">网红黑料石锤</strong>，
            收录<strong className="font-semibold text-accent-200">网红黑料原视频</strong>、<strong className="font-semibold text-accent-200">网红黑料录屏</strong>与<strong className="font-semibold text-accent-200">网红黑料原始截图</strong>，
            有图有真相，带你还原现场。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#archive"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-folder-open-line"></i>
              进入素材归档
            </a>
            <a
              href="#verify"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
            >
              <i className="ri-shield-check-line"></i>
              查看核验说明
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-2 md:gap-3">
            {['原视频留存', '录屏存档', '原始截图', '已核验 18 条'].map((chip) => (
              <span
                key={chip}
                className="px-3 md:px-4 py-1.5 rounded-full bg-foreground-950/35 border border-background-50/20 text-background-100 text-xs md:text-sm font-label"
              >
                {chip}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}